export default "__VITE_ASSET__BVDiohQq__"